import * as React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { vendorWithModelOptions } from '../../pages/CrudCalyxWaterMeters';

export const blankWaterMeter = {
  serialNumber: '',
  hardwareSerial: '',
  vendorWithModel: null,
};

/**
 * @type {React.FunctionComponent<{
 *   isOpen: boolean;
 *   onSave?: () => void;
 *   onCancel?: () => void;
 * }>}
 */
const NewWaterMeterDialog = (props) => {
  const { isOpen, onSave, onCancel } = props;

  const [waterMeter, setWaterMeter] = React.useState(blankWaterMeter);

  const isInputValid = React.useMemo(() => {
    if (waterMeter.serialNumber === '') return false;
    if (waterMeter.hardwareSerial === '') return false;
    if (waterMeter.vendorWithModel == null) return false;
    return true;
  }, [waterMeter]);

  React.useEffect(() => {
    setWaterMeter(blankWaterMeter);
  }, [isOpen]);

  return (
    <Dialog
      visible={isOpen}
      header={
        <>
          New Water Meter
        </>
      }
      footer={
        <>
          <Button label='Cancel' icon='pi pi-times' text onClick={() => onCancel?.()} />
          <Button label='Save' icon='pi pi-check' text onClick={() => onSave?.(waterMeter)} disabled={!isInputValid} />
        </>
      }
      style={{ width: '600px' }}
      blockScroll
      onHide={() => onCancel?.()}
    >
      <div className="flex flex-column gap-3">
        <div className="flex flex-column gap-2">
          <label>Serial Number</label>
          <InputText
            value={waterMeter.serialNumber}
            invalid={waterMeter.serialNumber === ''}
            onInput={(event) => setWaterMeter((val) => ({ ...val, serialNumber: event.target.value.trim() }))}
          />
          {waterMeter.serialNumber === '' && <small className="text-red-500">Serial Number is required.</small>}
        </div>
        <div className="flex flex-column gap-2">
          <label>Hardware Serial</label>
          <InputText
            value={waterMeter.hardwareSerial}
            invalid={waterMeter.hardwareSerial === ''}
            onInput={(event) => setWaterMeter((val) => ({ ...val, hardwareSerial: event.target.value.trim() }))}
          />
          {waterMeter.hardwareSerial === '' && <small className="text-red-500">Hardware Serial is required.</small>}
        </div>
        <div className="flex flex-column gap-2">
          <label>Vendor with Model</label>
          <Dropdown
            value={waterMeter.vendorWithModel}
            invalid={waterMeter.vendorWithModel == null}
            options={vendorWithModelOptions}
            optionLabel="label"
            optionValue="value"
            onChange={(event) => setWaterMeter((val) => ({ ...val, vendorWithModel: event.value }))}
          />
          {waterMeter.vendorWithModel == null && <small className="text-red-500">Vendor with Model is required.</small>}
        </div>
      </div>
    </Dialog>
  );
};

export default NewWaterMeterDialog;
